export const ImageBlock = ({ isActive, onClick, image }: { isActive: boolean; onClick: () => void; image: string }) => (
  <div className={`image ${isActive ? "active" : ""}`} onClick={onClick} style={{ backgroundImage: `url(${image})` }} />
);
